interface CheckMarkProps {
  backgroundColor: string;
}

export const CheckMark = ({
  backgroundColor,
}: CheckMarkProps) => (
  <svg
    width="54"
    height="54"
    viewBox="0 0 54 54"
    role="presentation"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27 4.5C14.58 4.5 4.5 14.58 4.5 27C4.5 39.42 14.58 49.5 27 49.5C39.42 49.5 49.5 39.42 49.5 27C49.5 14.58 39.42 4.5 27 4.5ZM27 45C17.0775 45 9 36.9225 9 27C9 17.0775 17.0775 9 27 9C36.9225 9 45 17.0775 45 27C45 36.9225 36.9225 45 27 45ZM37.3275 17.055L22.5 31.8825L16.6725 26.0775L13.5 29.25L22.5 38.25L40.5 20.25L37.3275 17.055Z"
      fill={backgroundColor}
    />
  </svg>
);
